import { render, staticRenderFns } from "./UserCampaignsDialog.vue?vue&type=template&id=2330d37b&"
import script from "./UserCampaignsDialog.vue?vue&type=script&lang=ts&"
export * from "./UserCampaignsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports